// Feature flags — set to true to enable, false to hide
// Phase 2 features are flagged off for Day 1 launch
export const FEATURES = {
  BLOG: false,        // Phase 2 — community blog
  MARKETPLACE: false, // Phase 2 — buy & swap listings
};
